export const MARKET_COUNTRY_OPTIONS = Object.freeze([
    Object.freeze(['US', 'United States']),
    Object.freeze(['CA', 'Canada']),
    Object.freeze(['GB', 'United Kingdom']),
    Object.freeze(['AU', 'Australia']),
    Object.freeze(['NZ', 'New Zealand']),
    Object.freeze(['IE', 'Ireland']),
]);

export const MARKET_CURRENCY_OPTIONS = Object.freeze([
    Object.freeze(['USD', 'USD - US Dollar']),
    Object.freeze(['CAD', 'CAD - Canadian Dollar']),
    Object.freeze(['GBP', 'GBP - British Pound']),
    Object.freeze(['AUD', 'AUD - Australian Dollar']),
    Object.freeze(['NZD', 'NZD - New Zealand Dollar']),
    Object.freeze(['EUR', 'EUR - Euro']),
]);
export const ALL_MARKET_COUNTRIES = 'ALL';

const MARKET_COUNTRY_CODES = new Set(MARKET_COUNTRY_OPTIONS.map(([code]) => code));
const MARKET_CURRENCY_CODES = new Set(MARKET_CURRENCY_OPTIONS.map(([code]) => code));

export function normalizeMarketCountries(value, fallback = null) {
    const countries = Array.isArray(value)
        ? value
        : Array.isArray(fallback) ? fallback : null;
    if (!countries) return fallback;

    return [...new Set(countries.map(country => String(country).trim().toUpperCase()))]
        .filter(country => MARKET_COUNTRY_CODES.has(country));
}

export function normalizeMarketAvailabilityCountries(value, fallback = null) {
    const countries = Array.isArray(value)
        ? value
        : Array.isArray(fallback) ? fallback : null;
    if (!countries) return fallback;

    return [...new Set(countries.map(country => String(country).trim().toUpperCase()))]
        .filter(country => country === ALL_MARKET_COUNTRIES
            || MARKET_COUNTRY_CODES.has(country));
}

export function normalizeMarketCurrency(value, fallback = 'USD') {
    const code = String(value || '').trim().toUpperCase();
    return MARKET_CURRENCY_CODES.has(code) ? code : fallback;
}

export function formatMarketAmount(cents, currency = 'USD') {
    const code = normalizeMarketCurrency(currency);
    const amount = Number(cents);
    const safeAmount = Number.isFinite(amount) ? amount : 0;

    return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: code,
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    }).format(safeAmount / 100);
}

export function getMarketCurrencySymbol(currency = 'USD') {
    const code = normalizeMarketCurrency(currency);
    const currencyPart = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: code,
    }).formatToParts(0).find(part => part.type === 'currency');
    return currencyPart?.value || code;
}

export function formatMarketCountries(countries) {
    if (!Array.isArray(countries)) return '';
    const names = new Map(MARKET_COUNTRY_OPTIONS);
    return countries.map(country => (
        country === ALL_MARKET_COUNTRIES ? 'All supported countries' : names.get(country) || country
    )).join(', ');
}
